// extracted by mini-css-extract-plugin
module.exports = {"search-item":"SearchItem_search-item__sfpcN","search-item-row":"SearchItem_search-item-row__3ahdc","search-item-col":"SearchItem_search-item-col__HrS_3"};